import { Injectable } from '@angular/core';
import { ILanguageCodeValue } from 'libraries/pipes/localized/localized.interface';
import { LocalizedPipe } from 'libraries/pipes/localized/localized.pipe';

@Injectable()
export class FareFamilyService {

    constructor(
        private readonly localizedPipe: LocalizedPipe,
    ){}

    public getName(name: ILanguageCodeValue): string {
        if (name.languageCode) {
            return this.localizedPipe.transform([name]);
        }
        return name.value || '';
    }
}
